export default {
  "number.edition_wearable_number": "Edition",
  "string.tag": "Tag",
  "string.position": "Position",
  "string.template": "Template",
  "amount_alias": "Currency",
};
